/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Poznávejte nové lidi, povídejte si, seznamujte se",
      "Nesprávné telefoní číslo",
      "Get the app",
      "Pokračovat s Apple",
      "Pokračovat s Facebookem",
      "Pokračovat s Google",
      "Přihlášení",
      "Registrace",
      "Chcete-li pokračovat, zadejte do políčka znaky, které vidíte.",
      "Pokračovat",
      "Zadejte znaky",
      "Bezpečnostní kontrola",
      "Načíst znovu",
      "Vytvořte si nové heslo, které si snadno zapamatujete:",
      "Aktualizovat",
      "Potvrdit heslo",
      "Heslo musí mít alespoň {{num}} [[characters:num@3]]",
      "Heslo",
      "Vytvořit nové heslo",
      "Badoo - Blog",
      "Kariéra",
      "Chat",
      "Města",
      "Spravovat soubory cookies",
      "Copyright © 2006 – moment. Bumble. Všechna práva vyhrazena.",
      "Apple a logo Apple jsou ochrannými známkami společnosti Apple Inc.{{__EOL__}}Google Play je ochranná známka společnosti Google LLC.",
      "Stáhnout",
      "Facebook",
      "Sledujte nás",
      "Centrum nápovědy",
      "Instagram",
      "Jazyk",
      "LinkedIn",
      "Přehled",
      "Badoo je součástí Bumble Inc.",
      "Zásady ochrany soukromí",
      "Safety Centre",
      "Mapa webu",
      "Prohlášení o zákoně o moderním otroctví",
      "Podmínky a ujednání",
      "Twitter",
      "Zadejte svůj e-mail nebo telefonní číslo a my vám odešleme instrukce k vytvoření nového hesla.",
      "Nastavit nové heslo",
      "Zadejte svůj e-mail nebo telefonní číslo",
      "Zapomenuté heslo",
      "Modelky a modelové pouze pro ilustrační účely",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Nemusíte čekat na shodu.{{__EOL__}}{{__EOL__}}Přeskočte přímo do konverzace, která vás zavede dál, hlouběji a přímo k tomu nejlepšímu. Vždyť víte. Tam, kde se opravdu poznáte.",
      "Připraveni chatovat?",
      "Provedením registrace souhlasíte s našimi <a class=\"link\" href=\"{{terms_url}}\">Podmínkami</a>. V našich <a class=\"link\" href=\"{{privacy_url}}\">Zásadách ochrany soukromí</a> se dozvíte, jak vaše údaje používáme.",
      "Pomáháme vám, abyste do seznamování <br />mohli vkládat více svého skutečného já a cítili se dobře.",
      "Věřte si při seznamování",
      "nebo",
      "Už máte účet?",
      "Zaregistrujte se pomocí e-mailu nebo telefonního čísla",
      "Dostanete to, co chcete.{{__EOL__}}Není třeba se omlouvat.",
      "Chcete jen chatovat? V pořádku.{{__EOL__}}Chcete se usadit? Může být.{{__EOL__}}{{__EOL__}}Rozmysleli jste si to? Žádný problém.",
      "Chci jít na rande",
      "Hledám vztah",
      "Chci chatovat",
      "Seznamujte se s lidmi, kteří chtějí totéž.",
      "{{name}}, {{age}}",
      "Vaše bezpečnost je pro nás prioritou číslo jedna.",
      "Naše Safety Centre je centrum praktických rad, ve kterém najdete veškerou podporu, kterou potřebujete k bezpečnému seznamování.",
      "Navštivte naše Safety Centre",
      "Bezpečnost na prvním místě,<br/>na druhém a prostě pořád.",
      "Hned od první chvíle jsem věděl, že to bude klapat…",
      "Ze začátku jsem nechtěla nic vážnýho…",
      "Jednou z rad pro všechny uživatele aplikace Badoo je, aby byli sami sebou…",
      "Příběhy úspěchů na Badoo",
      "Omrkněte další příběhy úspěchů",
      "{{num}}__CUT__Hodnocení",
      "Apple App Store",
      "Věřte nám. Od roku 2006 jsme spojili už milióny a milióny (a milióny) lidí.",
      "{{num}}M+__CUT__Stahování",
      "{{num}}M+",
      "Google Play Store",
      "Víme, co děláme.",
      "Přihlaste se pomocí svého e-mailu nebo telefonního čísla",
      "Zadejte své heslo",
      "Zapomněli jste heslo?",
      "Registrace",
      "Nemáte účet?",
      "Přihlášení",
      "Registrace"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "few": [
                  "znaky",
                  "znaků",
                  "znakům",
                  "znaky",
                  "znacích",
                  "znaky",
                  "znaky"
            ],
            "many": [
                  "znaků",
                  "znaků",
                  "znakům",
                  "znaků",
                  "znacích",
                  "znaky",
                  "znaků"
            ],
            "plural": [
                  "znaků",
                  "znaků",
                  "znakům",
                  "znaků",
                  "znacích",
                  "znaky",
                  "znaků"
            ],
            "singular": [
                  "znak",
                  "znaku",
                  "znaku",
                  "znak",
                  "znaku",
                  "znakem",
                  "znaku"
            ]
      },
      "day": {
            "few": [
                  "dny",
                  "dní",
                  "dnům",
                  "dny",
                  "dnech",
                  "dny",
                  "dny"
            ],
            "many": [
                  "dne",
                  "dne",
                  "dne",
                  "dne",
                  "dne",
                  "dne",
                  "dne"
            ],
            "plural": [
                  "dní",
                  "dní",
                  "dnům",
                  "dní",
                  "dnech",
                  "dny",
                  "dní"
            ],
            "singular": [
                  "den",
                  "dne",
                  "dni",
                  "den",
                  "dni",
                  "dnem",
                  "dne"
            ]
      },
      "hour": {
            "few": [
                  "hodiny",
                  "hodin",
                  "hodinám",
                  "hodiny",
                  "hodinách",
                  "hodinami",
                  "hodiny"
            ],
            "many": [
                  "hodiny",
                  "hodiny",
                  "hodiny",
                  "hodiny",
                  "hodiny",
                  "hodiny",
                  "hodiny"
            ],
            "plural": [
                  "hodin",
                  "hodin",
                  "hodinám",
                  "hodin",
                  "hodinách",
                  "hodinami",
                  "hodin"
            ],
            "singular": [
                  "hodina",
                  "hodiny",
                  "hodině",
                  "hodinu",
                  "hodině",
                  "hodinou",
                  "hodino"
            ]
      },
      "minute": {
            "few": [
                  "minuty",
                  "minut",
                  "minutám",
                  "minuty",
                  "minutách",
                  "minutami",
                  "minuty"
            ],
            "many": [
                  "minuty",
                  "minuty",
                  "minuty",
                  "minuty",
                  "minuty",
                  "minuty",
                  "minuty"
            ],
            "plural": [
                  "minut",
                  "minut",
                  "minutám",
                  "minut",
                  "minutách",
                  "minutami",
                  "minut"
            ],
            "singular": [
                  "minuta",
                  "minuty",
                  "minutě",
                  "minutu",
                  "minutě",
                  "minutou",
                  "minuto"
            ]
      },
      "month": {
            "few": [
                  "měsíce",
                  "měsíců",
                  "měsícům",
                  "měsíce",
                  "měsících",
                  "měsíci",
                  "měsíce"
            ],
            "many": [
                  "měsíce",
                  "měsíce",
                  "měsíce",
                  "měsíce",
                  "měsíce",
                  "měsíce",
                  "měsíce"
            ],
            "plural": [
                  "měsíců",
                  "měsíců",
                  "měsícům",
                  "měsíců",
                  "měsících",
                  "měsíci",
                  "měsíců"
            ],
            "singular": [
                  "měsíc",
                  "měsíce",
                  "měsíci",
                  "měsíc",
                  "měsíci",
                  "měsícem",
                  "měsíc"
            ]
      },
      "second": {
            "few": [
                  "vteřiny",
                  "vteřin",
                  "vteřinám",
                  "vteřiny",
                  "vteřinách",
                  "vteřinami",
                  "vteřiny"
            ],
            "many": [
                  "vteřiny",
                  "vteřiny",
                  "vteřiny",
                  "vteřiny",
                  "vteřiny",
                  "vteřiny",
                  "vteřiny"
            ],
            "plural": [
                  "vteřin",
                  "vteřin",
                  "vteřinám",
                  "vteřin",
                  "vteřinách",
                  "vteřinami",
                  "vteřin"
            ],
            "singular": [
                  "vteřina",
                  "vteřiny",
                  "vteřině",
                  "vteřinu",
                  "vteřině",
                  "vteřinou",
                  "vteřino"
            ]
      },
      "year": {
            "few": [
                  "roky",
                  "let",
                  "rokům",
                  "roky",
                  "letech",
                  "roky",
                  "roky"
            ],
            "many": [
                  "roku",
                  "roku",
                  "roku",
                  "roku",
                  "roku",
                  "roku",
                  "roku"
            ],
            "plural": [
                  "let",
                  "let",
                  "rokům",
                  "let",
                  "letech",
                  "roky",
                  "let"
            ],
            "singular": [
                  "rok",
                  "roku",
                  "roku",
                  "rok",
                  "roku",
                  "rokem",
                  "roku"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
